"use client";

import React, { useEffect } from "react";
import DownloadDocumentForm from "./forms/DownloadDocumentForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays, faFile } from "@fortawesome/sharp-light-svg-icons";
import { TriangleSvg } from "./icons/triangle";
import { CaseData, CMSData, CmsPage } from "@/cms/models";
import Button from "./ui/Button";
import ViewingForm from "./forms/ViewingForm";
import OpenHouseForm from "./forms/OpenhouseForm";
import BidForm from "./forms/BidForm";

export interface DocumentSectionProps {
  caseData: CaseData;
  app: any;
  cmsData: CMSData;
  pageData: CmsPage;
  selectedView: "openhouse" | "documents" | "viewing" | "bid";
  setSelectedView: (
    view: "openhouse" | "documents" | "viewing" | "bid"
  ) => void;
}

const CaseTabsComponent: React.FC<DocumentSectionProps> = ({
  caseData,
  app,
  cmsData,
  pageData,
  selectedView,
  setSelectedView,
}) => {


  useEffect(() => {
    if (!window) {
      return;
    }

    const handleSelectedTabEvent = (event: any) => {
      console.log("selectedTabEvent", event.detail.selectedTab);
      setSelectedView(event.detail.selectedTab);
    };

    window.addEventListener("selectedTabEvent", handleSelectedTabEvent);
  }, []);

  return (
    <div id="caseTabsComponent" className="flex flex-col gap-6 lg:gap-0 bg-[#ecf0f1]">
      <div className="flex flex-col bg-white lg:flex-row gap-4">
        <Button
          isActive={selectedView === "viewing"}
          onClick={() => setSelectedView("viewing")}
        >
          <FontAwesomeIcon className="size-4" icon={faCalendarDays} />
          <span>Bestil fremvisning</span>
          {selectedView === "viewing" && (
            <span className="hidden text-[var(--button-active-bg-color)] lg:block absolute bottom-[-10px] left-[15%] transform -translate-x-1/2">
              <TriangleSvg />
            </span>
          )}
        </Button>
        {caseData?.openhouses &&
          caseData.openhouses.filter((x) => x.bookingRequired).length > 0 && (
            <Button
              isActive={selectedView === "openhouse"}
              onClick={() => setSelectedView("openhouse")}
            >
              <FontAwesomeIcon className="size-4" icon={faCalendarDays} />
              <span>Tilmeld åbent hus</span>
              {selectedView === "openhouse" && (
                <span className="hidden text-[var(--button-active-bg-color)] lg:block absolute bottom-[-10px] left-[15%] transform -translate-x-1/2">
                  <TriangleSvg />
                </span>
              )}
            </Button>
          )}
        {caseData?.documents && caseData?.documents?.length > 0 && (
          <Button
            isActive={selectedView === "documents"}
            onClick={() => setSelectedView("documents")}
          >
            <FontAwesomeIcon className="size-4" icon={faFile} />
            <span>{caseData.isRental
                    ? "Bestil lejemateriale"
                    : "Bestil salgsmateriale"}</span>
            {selectedView === "documents" && (
              <span className="hidden text-[var(--button-active-bg-color)] lg:block absolute bottom-[-10px] left-[15%] transform -translate-x-1/2">
                <TriangleSvg />
              </span>
            )}
          </Button>
        )}
        {caseData?.canSendBid && (
          <Button
            isActive={selectedView === "bid"}
            onClick={() => setSelectedView("bid")}
          >
            <FontAwesomeIcon className="size-4" icon={faFile} />
            <span>Giv et bud</span>
            {selectedView === "bid" && (
              <span className="hidden text-[var(--button-active-bg-color)] lg:block absolute bottom-[-10px] left-[15%] transform -translate-x-1/2">
                <TriangleSvg />
              </span>
            )}
          </Button>
        )}
      </div>
      <div className="p-4">
        {selectedView === "openhouse" &&
          caseData?.openhouses &&
          caseData.openhouses.filter((x) => x.bookingRequired).length > 0 && (
            <OpenHouseForm caseData={caseData!} appData={app} cmsData={cmsData} />
          )}
        {selectedView === "documents" && (
          <DownloadDocumentForm
            caseData={caseData}
            appData={app}
            cmsData={cmsData}
            pageData={pageData}
          />
        )}
        {selectedView === "viewing" && (
          <ViewingForm caseData={caseData!} appData={app} cmsData={cmsData} />
        )}
        {selectedView === "bid" && (
          <BidForm caseData={caseData!} appData={app} cmsData={cmsData} />
        )}
      </div>
    </div>
  );
};

export default CaseTabsComponent;
